import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Subject } from "rxjs";
import { finalize, takeUntil } from "rxjs/operators";
import { ErrorType } from "src/app/enums/error-type.enum";
import endpoints from "src/app/helpers/endpoints";
import { ApiService } from "src/app/services/api.service";
import { ClaimActionsService } from "../../../services/claim-actions.service";
import { CommonService } from "src/app/services/common.service";

@Component({
  selector: "fury-view-assigned-technician",
  templateUrl: "./view-assigned-technician.component.html",
  styleUrls: ["./view-assigned-technician.component.scss"],
})
export class ViewAssignedTechnicianComponent implements OnInit, OnDestroy {
  ngUnsubscribe = new Subject();
  isLoading = false;
  technicianDetails: any;
  serviceStatusForm = new FormGroup({
    serviceStatus: new FormControl("Pending", Validators.required),
  });
  serviceStatus = ["Pending", "In Progress", "Completed"];
  submitType = {
    changeStatus: "changeStatus",
    assignOrEditTechnician: "assignOrEditTechnician",
    addTechnicianSchedule: "addTechnicianSchedule"
  }
  isFetchingData = false;
  constructor(
    public dialogRef: MatDialogRef<ViewAssignedTechnicianComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private apiService: ApiService,
    private claimActionsService: ClaimActionsService,
    public commonService: CommonService
  ) {}

  ngOnInit(): void {
    if(this.data?.fileClaimId) this.getAssignTechnician();
  }
  onNoClick() {
    this.dialogRef.close();
  }
  getAssignTechnician() {
    this.isFetchingData = true;
    this.apiService
      .get(endpoints.fileAClaim.getAssignTechnician(this.data?.fileClaimId))
      .pipe(finalize(()=> this.isFetchingData = false), takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (response: HttpResponse<any>) => {
          if (response.body) {
            this.technicianDetails = response.body;
            this.serviceStatusForm.setValue({
              serviceStatus: this.technicianDetails?.serviceStatus || 'Pending',
            })
          }
        },
        error: (error: HttpErrorResponse) => {
          this.apiService.alert(error?.message, ErrorType.Error);
        },
      });
  }
  changeServiceStatus(submitType: string) {
    if(submitType === this.submitType.addTechnicianSchedule && !this.technicianDetails?.assignedTechnician) {
      this.apiService.alert('Please assign a technician first', ErrorType.Error);
      return;
    }
    if(submitType === this.submitType.assignOrEditTechnician && !this.technicianDetails?.assignedTechnician) {
      this.assignTechnician(this.submitType.assignOrEditTechnician);
      this.onNoClick();
      return;
    }
    if (this.serviceStatusForm.invalid) {
      this.serviceStatusForm.markAllAsTouched();
      return;
    }
    this.isLoading = true;
    this.apiService
      .patch(
        endpoints.fileAClaim.changeServiceStatus(this.data?.fileClaimId),
        this.serviceStatusForm.value
      )
      .pipe(
        finalize(() => (this.isLoading = false)),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe({
        next: (res: HttpResponse<any>) => {
          if (res.body) {
            this.apiService.alert(res.body?.message, ErrorType.Success);
            if(submitType === this.submitType.changeStatus) {
              this.dialogRef.close(true);
              return;
            }
            if(submitType === this.submitType.assignOrEditTechnician) {
              this.assignTechnician(this.submitType.assignOrEditTechnician);
              this.dialogRef.close(true);
              return;
            }
            if(submitType === this.submitType.addTechnicianSchedule) {
              this.addTechnicianSchedule(this.submitType.addTechnicianSchedule);
              this.dialogRef.close(true);
              return;
            }
          }
        },
        error: (error: HttpErrorResponse) => {
          this.apiService.alert(error?.message, ErrorType.Error);
        },
      });
  }
  assignTechnician(modalName: string) {
    this.claimActionsService.openActionModal(this.data?.fileClaimId, modalName,  this.data?.services, this.data?.propertyAddress?.zip);
  }
  addTechnicianSchedule(modalName: string) {
    this.claimActionsService.openActionModal(this.data?.fileClaimId, modalName);
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
